import TagManager from 'react-gtm-module';
import { login } from '@bonanza-social/auth/state';
import { submitSocialRegistrationForm } from '@bonanza-social/registration/state';
import { apiConfig } from '@bonanza-social/toolkit/api';
import {
  appAuthenticated,
  startListening,
} from '@bonanza-social/toolkit/state';
import { logInfo } from '@bonanza-social/toolkit/logging';
import { jwtDecode } from 'jwt-decode';
import { mapRegistrationCompletedEventData } from './gtm.utils';

export const initGtm = () => {
  logInfo('Initialising GTM v1...');

  const tagManagerArgs = {
    gtmId: 'GTM-KWVF5TDF',
  };

  TagManager.initialize(tagManagerArgs);
};

if (!__DEV__) {
  // Disable GTM until further decision is made
  // startListening({
  //   actionCreator: appOpened,
  //   effect: () => {
  //     initGtm();
  //   },
  // });

  startListening({
    actionCreator: login.fulfilled,
    effect: (action) => {
      const profile = jwtDecode(action.payload.id_token);

      if (profile.sub) {
        window.gtmDataLayer?.push({
          event: 'login',
          method: 'Manual login', // user is automatically logged in after registration process
          user_id: profile.sub, // push internal userID/customer ID
        });
      }
    },
  });

  startListening({
    actionCreator: appAuthenticated,
    effect: async () => {
      const userId = await apiConfig.getUserId();

      window.gtmDataLayer?.push({
        login_status: userId ? 'Logged in' : 'Not logged in',
        user_id: userId,
      });
    },
  });

  startListening({
    actionCreator: submitSocialRegistrationForm.fulfilled,
    effect: (action) => {
      const params = mapRegistrationCompletedEventData(action.payload);

      window.gtmDataLayer?.push({
        event: 'registration_process_completed',
        ...params,
      });
    },
  });
}

declare global {
  interface Window {
    gtmDataLayer?: {
      push: (event: unknown) => void;
    };
  }
}
